// https://getbootstrap.com/docs/5.3/customize/color-modes/#javascript

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['currentColor', 'colorSwitch']

  getStoredTheme() {
    return localStorage.getItem('theme')
  }

  setStoredTheme(theme) {
    localStorage.setItem('theme', theme)
  }

  getPreferredTheme() {
    const storedTheme = this.getStoredTheme()

    if (storedTheme) {
      return storedTheme
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  setTheme(theme) {
    let finalTheme = theme

    if (theme === 'auto') {
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        finalTheme = 'dark'
      } else {
        finalTheme = 'light'
      }
    }

    document.documentElement.setAttribute('data-bs-theme', finalTheme)
    // document.querySelector('body').setAttribute('data-bs-theme', finalTheme)
    // document.querySelector('#top-menu').setAttribute('data-bs-theme', finalTheme)

    // This kinda works with $color-mode-type: media-query
    // But doesn't always switch mode in Safari
    // for (var s = 0; s < document.styleSheets.length; s++) {
    //   for (var i = 0; i < document.styleSheets[s].cssRules.length; i++) {
    //     let rule = document.styleSheets[s].cssRules[i];

    //     if (rule && rule.media && rule.media.mediaText.includes('prefers-color-scheme')) {
    //       switch (finalTheme) {
    //         case 'light':
    //           rule.media.appendMedium('original-prefers-color-scheme');
    //           if (rule.media.mediaText.includes('light')) rule.media.deleteMedium('(prefers-color-scheme: light)');
    //           if (rule.media.mediaText.includes('dark')) rule.media.deleteMedium('(prefers-color-scheme: dark)');
    //           break;
    //         case 'dark':
    //           rule.media.appendMedium('(prefers-color-scheme: light)');
    //           rule.media.appendMedium('(prefers-color-scheme: dark)');
    //           if (rule.media.mediaText.includes('original')) rule.media.deleteMedium('original-prefers-color-scheme');
    //           break;
    //         default:
    //           rule.media.appendMedium('(prefers-color-scheme: dark)');
    //           if (rule.media.mediaText.includes('light')) rule.media.deleteMedium('(prefers-color-scheme: light)');
    //           if (rule.media.mediaText.includes('original')) rule.media.deleteMedium('original-prefers-color-scheme');
    //           break;
    //       }
    //     }
    //   }
    // }
  }

  showActiveTheme(theme, focus = false) {
    this.colorSwitchTargets.forEach((element) => {
      element.classList.remove('active')
      element.setAttribute('aria-pressed', 'false')
    })

    const btnToActive = document.querySelector(`[data-theme='${theme}']`)

    btnToActive.classList.add('active')
    btnToActive.setAttribute('aria-pressed', 'true')

    this.currentColorTarget.querySelector('i').classList = btnToActive.querySelector('i').classList

    if (focus) {
      this.currentColorTarget.focus()
    }
  }

  changeTheme(event) {
    const { theme } = event.currentTarget.dataset

    this.setStoredTheme(theme)
    this.setTheme(theme)
    this.showActiveTheme(theme, true)
  }

  initialize() {
    this.setTheme(this.getPreferredTheme())

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      const storedTheme = this.getStoredTheme()

      if (storedTheme !== 'light' && storedTheme !== 'dark') {
        const theme = this.getPreferredTheme()

        this.setTheme(theme)
        this.showActiveTheme(theme)
      }
    })

    this.showActiveTheme(this.getPreferredTheme())
  }
}
